import { type VariantProps, cva } from 'class-variance-authority'
import type * as React from 'react'

import { cn } from '@/lib/client'

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
        outline: 'text-foreground',
        flag: 'rounded-xs w-[34px] h-[32px] border-none text-xs font-semibold leading-4 p-1',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({
  className,
  variant,
  bg,
  border_r,
  border_t,
  ...props
}: BadgeProps & { bg?: string; border_r?: string; border_t?: string }) {
  if (variant === 'flag') {
    return (
      <div className="relative top-[-20px]">
        <div
          className={cn(
            'rounded-[.2rem] flex flex-col items-center text-white text-center pt-[10px] px-[10px] relative bg-orange-500',
            bg && bg,
          )}
        >
          <div
            className={cn(badgeVariants({ variant }), className)}
            {...props}
          />
        </div>
        <div className="flex flex-row mt-[-1px]">
          <div
            className={cn(
              'border-t-transparent border-r-orange-500 border-b-transparent border-l-transparent border-solid border-t-0 border-r-[28px] border-b-[18px] border-l-0',
              border_r && border_r,
            )}
          />
          <div
            className={cn(
              'border-t-orange-500 border-r-transparent border-b-transparent border-solid border-t-[18px] border-r-[28px] border-b-0 border-l-0',
              border_t && border_t,
            )}
          />
        </div>
      </div>
    )
  }

  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
